import { Injectable, Pipe, PipeTransform } from '@angular/core';
var moment = require('moment');

@Pipe({
    name: 'dateTimeZone'
})
@Injectable()
export class DateTimeZonePipe implements PipeTransform {
    transform(value: any, pattern?: string, offset?: string): any {
        if(moment(value).isValid())
            return moment(value).utcOffset(offset).format(pattern);
        else
            return "";
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/pipes/dateTimeZonePipe.ts